import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ShieldHalfFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-half-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3v18"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 11h8.9"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 8h8.9"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 5h3.1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 17h6.2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 14h8"
    }, null), _createTextVNode(" ")]);
  }
};